// Copyright (c) 2017 Deere & Company

export default Object.freeze({
    DELETE_LABOR_RATE_FILE: 'DELETE_LABOR_RATE_FILE',
    UPDATE_LABOR_RATE_AVERAGE_TECH_PAY_RATE: 'UPDATE_LABOR_RATE_AVERAGE_TECH_PAY_RATE',
    UPDATE_LABOR_RATE_CHANGE_RATES: 'UPDATE_LABOR_RATE_CHANGE_RATES',
    UPDATE_LABOR_RATE_COMMENT: 'UPDATE_LABOR_RATE_COMMENT',
    UPDATE_LABOR_RATE_CONFIRMATION_MODAL_VISIBILITY: 'UPDATE_LABOR_RATE_CONFIRMATION_MODAL_VISIBILITY',
    UPDATE_LABOR_RATE_EFFECTIVE_DATE: 'UPDATE_LABOR_RATE_EFFECTIVE_DATE',
    UPDATE_LABOR_RATE_FILE: 'UPDATE_LABOR_RATE_FILE',
    UPDATE_LABOR_RATE_IS_SUBMIT_DISABLED: 'UPDATE_LABOR_RATE_IS_SUBMIT_DISABLED',
    UPDATE_LABOR_RATE_REQUESTED_RATE: 'UPDATE_LABOR_RATE_REQUESTED_RATE'
});



// WEBPACK FOOTER //
// ./src/claim/labor-rate-change/actions-list.js